<template>
  <div>
    <!--    기본정보-->
    <field-select-module
      v-model="form.stdInfo"
      :board="this.board"
      :is-print="isPrint"
    />

    <!--    요청자 구분-->
    <vs-row class="mt-6">
      <vs-col vs-type="flex" vs-justify="left" vs-align="center" w="12">
        <h5><i class="dot"></i> 요청자 구분</h5>
      </vs-col>
    </vs-row>
    <div class="grid grid-cols-6 gap-x-6 gap-y-4 mt-6">
      <div
        class="col-span-2 flex items-center"
        v-for="(row, indexRows) in checkList"
        :key="indexRows"
      >
        <div v-if="isPrint" class="flex items-center">
          <div
            v-if="row.is_check"
            style="background: #200c63"
            class="w-5 h-5 rounded-sm text-white flex justify-center items-center mr-2"
          >
            <vs-icon icon="check" size="x-small"></vs-icon>
          </div>
          <div
            v-else
            style="border: 2px solid rgb(180, 180, 180)"
            class="w-5 h-5 rounded-sm mr-2"
          ></div>
          <span class="flex-1">
            {{ row.title }}
          </span>
        </div>
        <div v-else>
          <span class="flex">
            <vs-checkbox
              :readonly="board.readonly"
              v-model="row.is_check"
              @change="changeCheckType($event, indexRows)"
            ></vs-checkbox>
            {{ row.title }}
          </span>
        </div>
      </div>
    </div>

    <!--    개선사항 요청-->

    <div class="print-container">
      <vs-row class="mt-8">
        <vs-col vs-type="flex" vs-justify="left" vs-align="center" w="12">
          <h5><i class="dot"></i> 유해·위험요인 점검(개선)사항 요청</h5>
        </vs-col>
      </vs-row>

      <div class="grid grid-cols-12 gap-x-6 gap-y-4 mt-4">
        <div class="col-span-4 flex items-center">
          <div class="label-text mr-4">사업장명</div>
          <p v-if="isPrint" class="print-input">{{ form.targetCompany }}</p>
          <company-selector
            v-else
            v-model="form.inputC_1"
            class="w-full flex-1"
            :field-id="form.stdInfo.field_id"
            @select="selectCompany"
          />
        </div>
        <div class="col-span-4 flex items-center">
          <div class="label-text mr-4">소속명</div>
          <p v-if="isPrint" class="print-input">{{ form.inputC_2 }}</p>
          <ml-input
            v-else
            v-model="form.inputC_2"
            class="w-full flex-1"
          />
        </div>
        <div class="col-span-4 flex items-center">
          <div class="label-text mr-4">부서명</div>
          <p v-if="isPrint" class="print-input">{{ form.inputC_3 }}</p>
          <ml-input
            v-else
            v-model="form.inputC_3"
            class="w-full flex-1"
          />
        </div>

        <div class="col-span-4 flex items-center">
          <div class="label-text mr-4">요청자</div>
          <p v-if="isPrint" class="print-input">{{ form.inputC_4 }}</p>
          <ml-input
            v-else
            v-model="form.inputC_4"
            class="w-full flex-1"
          />
        </div>
        <div class="col-span-4 flex items-center">
          <div class="label-text mr-4">대상</div>
          <p v-if="isPrint" class="print-input">{{ form.inputC_5 }}</p>
          <ml-input
            v-else
            v-model="form.inputC_5"
            class="w-full flex-1"
          />
        </div>
        <div class="col-span-4 flex items-center">
          <div class="label-text mr-4">재해형태</div>
          <p v-if="isPrint" class="print-input" style="color:red;">{{ form.inputC_6 }}</p>
          <disaster-class-selector
            v-else
            class="w-full flex-1"
            style="color:red;"
            v-model="form.inputC_6"
            :readonly="board.readonly"
          />
        </div>
      </div>

      <div class="print-container col-span-12 flex items-start mt-4">
        <div class="label-text mr-4 mt-2">점검 및 개선 사유</div>
        <p v-if="isPrint" class="print-textarea">{{ form.inputC_7 }}</p>
        <ml-textarea
          :readonly="board.readonly"
          v-else
          v-model="form.inputC_7"
          class="flex-1 w-full"
          rows="5"
        />
      </div>

      <div class="grid grid-cols-12 gap-x-6 gap-y-4">
        <div class="col-span-4 flex items-center">
          <div class="label-text mr-4">요청일</div>
          <p v-if="isPrint" class="print-input">{{ form.inputC_8 }}</p>
          <date-selector
            v-else
            class="w-full flex-1"
            v-model="form.inputC_8"
            :readonly="board.readonly"
          />
        </div>
<!--        <div class="col-span-4 flex items-center">-->
<!--          <div class="label-text mr-4">점검일</div>-->
<!--          <p v-if="isPrint" class="print-input">{{ form.inputC_9 }}</p>-->
<!--          <date-selector-->
<!--            v-else-->
<!--            class="w-full flex-1"-->
<!--            v-model="form.inputC_9"-->
<!--            :readonly="board.readonly"-->
<!--          />-->
<!--        </div>-->
<!--        <div class="col-span-4 flex items-center">-->
<!--          <div class="label-text mr-4">점검장소</div>-->
<!--          <p v-if="isPrint" class="print-input">{{ form.inputC_10 }}</p>-->
<!--          <ml-input-->
<!--            v-else-->
<!--            v-model="form.inputC_10"-->
<!--            class="w-full flex-1"-->
<!--          />-->
<!--        </div>-->
      </div>
    </div>

    <!--    조치 전 사진-->
    <photo-upload-grid-module
      :row-count="2"
      :grid-count="2"
      v-model="form.photoList_1"
      :is-print="isPrint"
      :readonly="board.readonly"
      section-title="조치 전 사진"
      placeholder="조치 전"
    />

    <!--    조치 현황 -->
    <div class="print-container">
      <vs-row class="mt-6">
        <vs-col vs-type="flex" vs-justify="left" vs-align="center" w="12">
          <h5><i class="dot"></i> 조치 현황</h5>
        </vs-col>
      </vs-row>

      <div class="grid grid-cols-12 gap-x-6 gap-y-4 mt-4">
        <div class="col-span-4 flex items-center">
          <div class="label-text mr-4">소속명</div>
          <p v-if="isPrint" class="print-input">{{ form.inputE_1 }}</p>
          <ml-input
            v-else
            v-model="form.inputE_1"
            class="w-full flex-1"
          />
        </div>
        <div class="col-span-4 flex items-center">
          <div class="label-text mr-4">부서명</div>
          <p v-if="isPrint" class="print-input">{{ form.inputE_2 }}</p>
          <ml-input
            v-else
            v-model="form.inputE_2"
            class="w-full flex-1"
          />
        </div>
        <div class="col-span-4 flex items-center">
          <div class="label-text mr-4">조치자</div>
          <p v-if="isPrint" class="print-input">{{ form.inputE_3 }}</p>
          <ml-input
            v-else
            v-model="form.inputE_3"
            class="w-full flex-1"
          />
        </div>

        <div class="col-span-4 flex items-center">
          <div class="label-text mr-4">조치 내용</div>
          <p v-if="isPrint" class="print-input">{{ form.inputE_4 }}</p>
          <ml-input
            v-else
            v-model="form.inputE_4"
            class="w-full flex-1"
          />
        </div>
        <div class="col-span-4 flex items-center">
          <div class="label-text mr-4">조치 현황</div>
          <p v-if="isPrint" class="print-input">{{ form.inputE_5 }}</p>
          <measure-state-selector
            v-else
            class="w-full flex-1"
            v-model="form.inputE_5"
            :readonly="board.readonly"
          />
        </div>
        <div class="col-span-4 flex items-center">
          <div class="label-text mr-4">조치 완료일</div>
          <p v-if="isPrint" class="print-input">{{ form.inputE_6 }}</p>
          <date-selector
            v-else
            class="w-full flex-1"
            v-model="form.inputE_6"
            :readonly="board.readonly"
          />
        </div>

<!--        <div class="col-span-4 flex items-center">-->
<!--          <div class="label-text mr-4">점검일</div>-->
<!--          <p v-if="isPrint" class="print-input">{{ form.inputE_7 }}</p>-->
<!--          <date-selector-->
<!--            v-else-->
<!--            class="w-full flex-1"-->
<!--            v-model="form.inputE_7"-->
<!--            :readonly="board.readonly"-->
<!--          />-->
<!--        </div>-->
<!--        <div class="col-span-4 flex items-center">-->
<!--          <div class="label-text mr-4">점검장소</div>-->
<!--          <p v-if="isPrint" class="print-input">{{ form.inputE_8 }}</p>-->
<!--          <ml-input-->
<!--            v-else-->
<!--            v-model="form.inputE_8"-->
<!--            class="w-full flex-1"-->
<!--          />-->
<!--        </div>-->
      </div>
    </div>

    <!--    조치 후 사진-->
    <photo-upload-grid-module
      :row-count="2"
      :grid-count="2"
      v-model="form.photoList_2"
      :is-print="isPrint"
      :readonly="board.readonly"
      section-title="조치 후 사진"
      placeholder="조치 후"
    />

    <!--    파일첨부-->
    <file-upload-module
      id="fileList"
      class="w-full mt-4"
      v-model="form.fileList"
      :is-print="isPrint"
      :readonly="board.readonly"
    ></file-upload-module>
  </div>
</template>

<script>
import PopupPlanProject from "@/views/project/popup/PopupPlanProject";
import DateSelector from "@/components/selector/DateSelector";
import PopupProjectSetting from "@/views/project/PopupProjectSetting";
import MemberSelector from "@/components/selector/MemberSelector";
import CompanySelector from "@/components/selector/CompanySelector";
import FileUploader from "@/components/FileUploader";
import FileUploadModule from "@/views/modules/FileUploadModule";
import TableInspect from "@/components/TableInspect";
import TableEquipment from "@/components/TableEquipment";
import DisasterClassSelector from "@/components/selector/DisasterClassSelector";
import MeasureStateSelector from "@/components/selector/MeasureStateSelector";
import FieldSelectModule from "@/views/modules/FieldSelectModule";
import PhotoUploadGridModule from "@/views/modules/PhotoUploadGridModule";

export default {
  components: {
    PhotoUploadGridModule,
    FieldSelectModule,
    MeasureStateSelector,
    FileUploadModule,
    TableInspect,
    TableEquipment,
    DisasterClassSelector,
    FileUploader,
    CompanySelector,
    MemberSelector,
    PopupProjectSetting,
    DateSelector,
    PopupPlanProject,
  },
  props: {
    isPrint: Boolean,
    board: Object,
    value: Object,
  },
  watch: {
    value: {
      immediate: true,
      deep: true,
      handler(value) {
        const keys = Object.keys(this.form);
        for (const key of keys) {
          if (value[key]) {
            this.form[key] = value[key];
          }
        }

        for (const data of this.checkList) {
          if (data.title === this.form.type) {
            data.is_check = true;
          }
        }
        // }
      },
    },
    form: {
      immediate: true,
      deep: true,
      handler(value) {
        value.title = this.board.writer.department;
        this.$emit("input", value);
      },
    },
  },
  data() {
    return {
      checkList: [
        { title: "사업주", is_check: false },
        { title: "근로자", is_check: false },
        { title: "기타", is_check: false },
      ],
      form: {
        stdInfo: {},

        inputC_1: "",
        inputC_2: "",
        inputC_3: "",
        inputC_4: "",
        inputC_5: "",
        inputC_6: "",
        inputC_7: "",
        inputC_8: "",
        inputC_9: "",
        inputC_10: "",

        inputE_1: "",
        inputE_2: "",
        inputE_3: "",
        inputE_4: "",
        inputE_5: "",
        inputE_6: "",
        inputE_7: "",
        inputE_8: "",

        photoList_1: [],
        photoList_2: [],
        type: "",
        fileList: [],
        targetCompany: '',
      },
    };
  },
  methods: {
    changeCheckType(value, index) {
      if (value.target.checked) {
        this.form.type = this.checkList[index].title;

        for (let i = 0; i < this.checkList.length; i++) {
          if (i !== index) {
            this.checkList[i].is_check = false;
          }
        }
      } else {
        this.form.type = "";
      }
    },
    selectCompany(value) {
      this.form.targetCompany = value.com_name;
    },
  },
};
</script>

<style scoped lang="scss">
$border: 1px solid #cdcdcd;
.label-text {
  width: 114px;
  font-weight: 500;
  font-size: 14px;
}
.mt-component-form {
  margin-top: 15px;
}

/* uploaded File */
.h-upload {
  height: 470px;
}
.upload-content {
  border: $border;
  &:last-child {
    border-left: none;
  }
  &__title {
    height: 54px;
    line-height: 54px;
    text-align: center;
    background: #fafafa;
    border-bottom: $border;
  }
  &__input {
    height: 54px;
    background: #f9f9f9;
    border-top: $border;
    padding: 5px 15px;
    display: flex;
    align-items: center;
    justify-content: center;
  }
  &__file {
    height: calc(100% - 54px);
    width: 100%;
    padding: 14px;
  }
}
</style>
